import { ACTIONS } from './consts'
import { ActionTree } from 'vuex'
import StateStoreAdapter from './types'

export default {
  [ACTIONS.UPDATE_TRACKING_DATA]: async ({ commit, state }) => {
    // TODO @cb: Send data to API -> moved to modules store cuz sessions are there
  }
} as ActionTree<StateStoreAdapter, any>
